var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name != 'userCenter')?_c('Top'):_vm._e(),_c('router-view',{class:{ appbox: true, haveTab: _vm.$route.meta.showTab }}),(_vm.$route.meta.showTab)?_c('tab-bar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }